import ecbbAsg from 'assets/img/2026/ecbb_asg.png';
import ecbbClientes from 'assets/img/2026/ecbb_clientes.png';
import ecbbCultura from 'assets/img/2026/ecbb_cultura.png';
import ecbbFinanceiro from 'assets/img/2026/ecbb_financeiro.png';
import ecbbTransformacao from 'assets/img/2026/ecbb_transformacao.png';
import logoPodio from 'assets/img/2026/logo_podio.png';
import negocios from 'assets/img/2026/negocios.png';
import simplificacao from 'assets/img/2026/simplificacao.png';
import sustentacao from 'assets/img/2026/sustentacao.png';
import React, { useEffect, useState } from 'react';
import { buscarIniciativasVencedoras } from 'services/iniciativa.service';
import { IniciativaFormatada } from 'types/iniciativa';
import { IniciativaCard } from './IniciativaCard';
import './Podio.scss';

// Por decisão do BB, a categoria "Negócios e Atendimento" (CONEXAO) premia dois
// colocados em cada posição do pódio, exibindo dois cards por colocação. As
// demais categorias mantêm um card por colocação.
const CATEGORIAS_COM_DOIS_POR_COLOCACAO = new Set(['CONEXAO']);

// Categoria mapeamento de imagem para tags de fallback
const CATEGORIA_IMGS: Record<string, string> = {
  ECBB_CLIENTES: ecbbClientes,
  ECBB_FINANCEIRO: ecbbFinanceiro,
  ECBB_ASG: ecbbAsg,
  ECBB_TDIGITAL: ecbbTransformacao,
  ECBB_CULTURA_PESSOAS: ecbbCultura,
  SIMPLIFIQUE: simplificacao,
  CONEXAO: negocios,
  PILAR: sustentacao,
};

// Dados fictícios de alta fidelidade (fallback) para garantir pódio completo em todas as categorias
const MOCK_FINALISTAS: Record<string, Array<Partial<IniciativaFormatada>>> = {
  ECBB_CLIENTES: [
    {
      id: 'mock_c1',
      titulo: 'Atendimento Expresso PJ',
      descricao: 'Redesenho do fluxo de atendimento de pessoas jurídicas nas agências digitais, reduzindo o tempo de espera em 40%.',
      autores: 'Mariana Costa, Roberto Souza, Fernando Lima',
      categoria: 'ECBB - Clientes',
      categoryPremio: 'ECBB_CLIENTES',
      corCategoria: '#4A5FFF',
      totalElogios: 35,
      totalFavoritos: 23,
      totalCompartilhamentos: 12,
      participantes: [
        { nome: 'Mariana Costa', matricula: '1111111', confirmado: true, isOwner: true },
        { nome: 'Roberto Souza', matricula: '2222222', confirmado: true },
        { nome: 'Fernando Lima', matricula: '3333333', confirmado: true }
      ]
    },
    {
      id: 'mock_c2',
      titulo: 'Portal Conectividade Agro',
      descricao: 'Plataforma integrada que conecta produtores rurais a serviços de crédito e suporte técnico imediato via inteligência artificial.',
      autores: 'Juliana Dias, André Santos, Bruno Rocha',
      categoria: 'ECBB - Clientes',
      categoryPremio: 'ECBB_CLIENTES',
      corCategoria: '#4A5FFF',
      totalElogios: 28,
      totalFavoritos: 19,
      totalCompartilhamentos: 8,
      participantes: [
        { nome: 'Juliana Dias', matricula: '4444444', confirmado: true, isOwner: true },
        { nome: 'André Santos', matricula: '5555555', confirmado: true },
        { nome: 'Bruno Rocha', matricula: '6666666', confirmado: true }
      ]
    },
    {
      id: 'mock_c3',
      titulo: 'App BB Acessível',
      descricao: 'Conjunto de novas ferramentas de acessibilidade integradas ao aplicativo móvel para deficientes visuais e idosos.',
      autores: 'Carla Silveira, Diego Mendes',
      categoria: 'ECBB - Clientes',
      categoryPremio: 'ECBB_CLIENTES',
      corCategoria: '#4A5FFF',
      totalElogios: 22,
      totalFavoritos: 15,
      totalCompartilhamentos: 6,
      participantes: [
        { nome: 'Carla Silveira', matricula: '7777777', confirmado: true, isOwner: true },
        { nome: 'Diego Mendes', matricula: '8888888', confirmado: true }
      ]
    }
  ],
  ECBB_FINANCEIRO: [
    {
      id: 'mock_f1',
      titulo: 'Custos Inteligentes com IA',
      descricao: 'Sistema autônomo baseado em redes neurais para auditoria prévia e otimização de contratos de terceirização bancária.',
      autores: 'Alexandre Cruz, Beatriz Melo',
      categoria: 'ECBB - Financeira',
      categoryPremio: 'ECBB_FINANCEIRO',
      corCategoria: '#10B981',
      totalElogios: 42,
      totalFavoritos: 26,
      totalCompartilhamentos: 18,
      participantes: [
        { nome: 'Alexandre Cruz', matricula: '1212121', confirmado: true, isOwner: true },
        { nome: 'Beatriz Melo', matricula: '2323232', confirmado: true }
      ]
    },
    {
      id: 'mock_f2',
      titulo: 'Dashboard de Eficiência Produtiva',
      descricao: 'Ferramenta de Business Intelligence em tempo real para controle do custo de transações financeiras de atacado.',
      autores: 'Gabriel Barbosa, Aline Fernandes, Ricardo Oliveira',
      categoria: 'ECBB - Financeira',
      categoryPremio: 'ECBB_FINANCEIRO',
      corCategoria: '#10B981',
      totalElogios: 31,
      totalFavoritos: 20,
      totalCompartilhamentos: 9,
      participantes: [
        { nome: 'Gabriel Barbosa', matricula: '3434343', confirmado: true, isOwner: true },
        { nome: 'Aline Fernandes', matricula: '4545454', confirmado: true },
        { nome: 'Ricardo Oliveira', matricula: '5656565', confirmado: true }
      ]
    },
    {
      id: 'mock_f3',
      titulo: 'Precificação Inteligente CDC',
      descricao: 'Algoritmo preditivo de demanda para cálculo em lote de taxas promocionais personalizadas em tempo recorde.',
      autores: 'Vanessa Lima, Tiago Alves',
      categoria: 'ECBB - Financeira',
      categoryPremio: 'ECBB_FINANCEIRO',
      corCategoria: '#10B981',
      totalElogios: 25,
      totalFavoritos: 14,
      totalCompartilhamentos: 7,
      participantes: [
        { nome: 'Vanessa Lima', matricula: '6767676', confirmado: true, isOwner: true },
        { nome: 'Tiago Alves', matricula: '7878787', confirmado: true }
      ]
    }
  ]
};

// Fallback genérico para as demais categorias
const getGenericFallback = (categoriaId: string, nomeAmigavel: string): Array<Partial<IniciativaFormatada>> => [
  {
    id: `mock_g1_${categoriaId}`,
    titulo: `Inovação Integrada - ${nomeAmigavel}`,
    descricao: `Iniciativa de alta performance desenvolvida com o objetivo de revolucionar as entregas e trazer resultados expressivos na categoria ${nomeAmigavel}.`,
    autores: 'Eduardo Oliveira, Roberta Santos, Camila Rocha',
    categoria: nomeAmigavel,
    categoryPremio: categoriaId,
    corCategoria: '#3B82F6',
    totalElogios: 30,
    totalFavoritos: 21,
    totalCompartilhamentos: 10,
    participantes: [
      { nome: 'Eduardo Oliveira', matricula: '9090901', confirmado: true, isOwner: true },
      { nome: 'Roberta Santos', matricula: '9090902', confirmado: true },
      { nome: 'Camila Rocha', matricula: '9090903', confirmado: true }
    ]
  },
  {
    id: `mock_g2_${categoriaId}`,
    titulo: `Eficiência e Foco - ${nomeAmigavel}`,
    descricao: `Otimização de processos essenciais da área para garantir maior sinergia, eliminando gargalos de comunicação e acelerando soluções pragmáticas.`,
    autores: 'Felipe Alencar, Patrícia Souza',
    categoria: nomeAmigavel,
    categoryPremio: categoriaId,
    corCategoria: '#3B82F6',
    totalElogios: 24,
    totalFavoritos: 16,
    totalCompartilhamentos: 6,
    participantes: [
      { nome: 'Felipe Alencar', matricula: '9090904', confirmado: true, isOwner: true },
      { nome: 'Patrícia Souza', matricula: '9090905', confirmado: true }
    ]
  },
  {
    id: `mock_g3_${categoriaId}`,
    titulo: `Transformação e Sinergia ${nomeAmigavel}`,
    descricao: `Plano de ação estruturado visando elevar o engajamento e a qualidade das entregas estratégicas da equipe em todo o território nacional.`,
    autores: 'Lucas Ramos, Isabela Costa',
    categoria: nomeAmigavel,
    categoryPremio: categoriaId,
    corCategoria: '#3B82F6',
    totalElogios: 18,
    totalFavoritos: 11,
    totalCompartilhamentos: 4,
    participantes: [
      { nome: 'Lucas Ramos', matricula: '9090906', confirmado: true, isOwner: true },
      { nome: 'Isabela Costa', matricula: '9090907', confirmado: true }
    ]
  }
];

// Completa o pódio com mock data quando não há vencedoras reais suficientes
// para preencher todas as colocações (o total varia conforme os cards por
// colocação da categoria). Os mocks reaproveitam os fallbacks com id único.
const preencherPodio = (
  reais: IniciativaFormatada[],
  total: number,
  categoriaId: string,
  categoriaNome: string
): IniciativaFormatada[] => {
  const fallbacks = MOCK_FINALISTAS[categoriaId] || getGenericFallback(categoriaId, categoriaNome);
  const preenchidas = [...reais];

  for (let i = reais.length; i < total && fallbacks.length > 0; i++) {
    const base = fallbacks[(i - reais.length) % fallbacks.length];
    preenchidas.push({ ...base, id: `${base.id}_${i}` } as IniciativaFormatada);
  }

  return preenchidas.slice(0, total);
};

interface PodioProps {
  categoriaId: string;
  categoriaNome: string;
}

export const Podio: React.FC<PodioProps> = ({ categoriaId, categoriaNome }) => {
  const [iniciativas, setIniciativas] = useState<IniciativaFormatada[]>([]);
  const [loading, setLoading] = useState(true);

  const cardsPorColocacao = CATEGORIAS_COM_DOIS_POR_COLOCACAO.has(categoriaId) ? 2 : 1;
  const totalCards = cardsPorColocacao * 3;

  useEffect(() => {
    async function carregarVencedores() {
      try {
        setLoading(true);
        const data = await buscarIniciativasVencedoras();

        // Filtra pela categoria correspondente
        const filtradas = data.filter(
          (ini) => ini.categoryPremio === categoriaId || ini.categoria === categoriaNome
        );

        // Ordena pela colocação definida no resultado final (position: 1 = 1º, 2 = 2º, 3 = 3º).
        // Iniciativas sem position vão para o fim, mantendo o desempate por elogios.
        const ordenadas = [...filtradas].sort((a, b) => {
          const posA = a.position ?? Number.POSITIVE_INFINITY;
          const posB = b.position ?? Number.POSITIVE_INFINITY;
          if (posA !== posB) return posA - posB;
          return b.totalElogios - a.totalElogios;
        });

        setIniciativas(preencherPodio(ordenadas, totalCards, categoriaId, categoriaNome));
      } catch (error) {
        console.error('Erro ao carregar pódio:', error);
        // Fallback total se a chamada falhar
        setIniciativas(preencherPodio([], totalCards, categoriaId, categoriaNome));
      } finally {
        setLoading(false);
      }
    }

    carregarVencedores();
  }, [categoriaId, categoriaNome, totalCards]);

  if (loading) {
    return (
      <div className="podio-loading">
        <div className="spinner"></div>
        <p>Carregando pódio da categoria...</p>
      </div>
    );
  }

  if (iniciativas.length < totalCards) return null;

  // Cards de cada colocação: sequência ordenada dividida em blocos de
  // `cardsPorColocacao` (1 por padrão; 2 nas categorias com dois colocados).
  const cardsDaColocacao = (colocacao: number) => {
    const inicio = (colocacao - 1) * cardsPorColocacao;
    return iniciativas.slice(inicio, inicio + cardsPorColocacao);
  };

  // No pódio do protótipo, a ordem visual é: 2º Lugar (Esquerda) | 1º Lugar (Centro) | 3º Lugar (Direita)
  const posicoes = [
    {
      colocacao: 2,
      label: '2º LUGAR',
      cards: cardsDaColocacao(2),
      styleClass: 'silver',
      pedestalClass: 'podio__step--2',
    },
    {
      colocacao: 1,
      label: '1º LUGAR',
      cards: cardsDaColocacao(1),
      styleClass: 'gold',
      pedestalClass: 'podio__step--1',
    },
    {
      colocacao: 3,
      label: '3º LUGAR',
      cards: cardsDaColocacao(3),
      styleClass: 'bronze',
      pedestalClass: 'podio__step--3',
    },
  ];

  return (
    <div className="podio-container">
      <div className="podio-layout">
        {posicoes.map(({ colocacao, label, cards, styleClass, pedestalClass }) => {
          if (cards.length === 0) return null;

          // Reutilizamos a media-frame do IniciativaCard (mesma estrutura física
          // das "classificadas"), trocando o ícone do troféu pelo logo_podio.png
          // e o texto pela posição no pódio. O gradiente gold/silver/bronze é
          // aplicado via SCSS por meio do modificador `podio-card--{styleClass}`.
          const isDupla = cardsPorColocacao > 1;

          return (
            <div key={colocacao} className={`podio-coluna podio-coluna--${styleClass}`}>
              {/* Os cards da colocação ficam lado a lado quando há mais de um. */}
              <div className="podio-cards">
                {cards.map((iniciativa) => (
                  <div key={iniciativa.id} className={`podio-card podio-card--${styleClass}`}>
                    <IniciativaCard
                      {...iniciativa}
                      classificadaEtapa1
                      classificadaEtapa2={false}
                      classificadaIcon={
                        <img
                          src={logoPodio}
                          alt=""
                          aria-hidden="true"
                          className="podio-card__logo"
                        />
                      }
                      classificadaLabel={label}
                      podioPosition={colocacao as 1 | 2 | 3}
                      compact={isDupla}
                      ocultarNaoValidos
                    />
                  </div>
                ))}
              </div>

              {/* Pedestal do Pódio */}
              <div className={`podio__step ${pedestalClass}`}>
                <div className="podio__step-number">{colocacao}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

